import { Controller } from 'stimulus'

// Slides a fixed bottom buy-bar into view (narrow viewports only) once the inline price
// box has scrolled out of view, and back out when the box returns. The bar sits on top of
// the cookie banner (higher z-index); the support launcher would be hidden behind it, so we
// lift the launcher up while the bar is visible. The cart icon proxies the inline
// Add-to-cart button so all cart logic, loading state, and notices are reused.
export default class extends Controller {
  static values = { sentinelId: String }

  // Bottom-right floating support launchers that must ride above the bar while it's shown.
  // The widgets style themselves with !important, so only an inline !important can move them.
  static LAUNCHER_SELECTORS = ['#simplero-ticket-launcher', '.hd-toggle-btn']

  connect() {
    this.sentinel = document.getElementById(this.sentinelIdValue)
    if (!this.sentinel) return

    this.observer = new IntersectionObserver(
      ([entry]) => this.toggle(!entry.isIntersecting),
      { threshold: 0 }
    )
    this.observer.observe(this.sentinel)
  }

  disconnect() {
    this.observer?.disconnect()
    this.toggle(false)
  }

  toggle(show) {
    this.element.classList.toggle('translate-y-full', !show)

    // Lift the launcher to sit 20px above the bar; clear the override when the bar hides.
    const bottom = show ? `${this.element.offsetHeight + 20}px` : null
    this.constructor.LAUNCHER_SELECTORS.forEach((selector) => {
      const launcher = document.querySelector(selector)
      if (!launcher) return
      if (show) launcher.style.setProperty('bottom', bottom, 'important')
      else launcher.style.removeProperty('bottom')
    })
  }

  addToCart() {
    this.sentinel?.querySelector('.js-cart-action')?.click()
  }
}
